export default "__VITE_ASSET__CWOkRXZI__"